import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAvailableGames } from './gameApi';

const initialState = {
    searchedGames: [],
    loading: false,
    error: null,
    providers: [],
};

export const fetchAvailableGamesApi = createAsyncThunk('games/fetchAvailableGames', async ({ selectedProviders, selectedGameType }, { rejectWithValue }) => {
    try {
        const data = await fetchAvailableGames({ selectedProviders, selectedGameType });
        return data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message);
    }
});

const gamesSlice = createSlice({
    name: 'games',
    initialState,
    reducers: {
        clearGames: (state) => {
            state.searchedGames = [];
            state.error = null;
            state.providers = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAvailableGamesApi.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.searchedGames = [];
                state.providers = [];
            })
            .addCase(fetchAvailableGamesApi.fulfilled, (state, action) => {
                const games = action.payload?.games || [];
                state.providers = action.payload?.providers || [];
                state.loading = false;
                state.searchedGames = games;
            })
            .addCase(fetchAvailableGamesApi.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.searchedGames = [];
                state.providers = [];
            });
    },
});

export const { clearGames } = gamesSlice.actions;
export default gamesSlice.reducer;
